export type ShopeeArgueOrdertatus =
  | 'UNKNOWN'
  | 'REQUESTED'
  | 'PROCESSING'
  | 'JUDGING'
  | 'SELLER_DISPUTE'
  | 'ACCEPTED'
  | 'CANCELLED'
  | 'REFUND_PAID'
  | 'CLOSED'
  | 'IN_CANCEL';
export type LazadaArgueOrderStatus =
  | 'REQUEST_INITIATE'
  | 'BUYER_RETURN_ITEM'
  | 'SELLER_REJECT_RETURN'
  | 'SELLER_AGREE_RETURN'
  | 'CS_APPROVING'
  | 'REFUND_PENDING'
  | 'REFUND_REJECT'
  | 'REFUND_SUCCESS'
  | 'REPLACE_SUCCESS'
  | 'SELLER_AGREE_REFUND'
  | 'CANCEL_SUCCESS'
  | 'AGREE_CANCEL_ORDER';

/**
 * done: 完成
 * pending: 需要商家点击按钮接入
 * processing: 等待平台处理
 */
export enum SimpleProcessStatus {
  Done,
  Pending,
  Processing,
}

export const simpleProccessStatusCalc = (
  platform: General.CaselessPlatform,
  statusRaw: ShopeeArgueOrdertatus | LazadaArgueOrderStatus | string,
) => {
  let simpleStatus: SimpleProcessStatus = SimpleProcessStatus.Processing;
  let allowDispute = false;
  if (/^lazada$/i.test(platform)) {
    const status = statusRaw as LazadaArgueOrderStatus;
    if (
      /^REFUND_SUCCESS|SELLER_REJECT_RETURN|SELLER_AGREE_RETURN|replace_success|seller_agree_refund|refund_reject|CANCEL_SUCCESS|REFUND_SUCCESS|AGREE_CANCEL_ORDER$/i.test(
        status,
      )
    ) {
      simpleStatus = SimpleProcessStatus.Done;
    } else if (
      /request_complete|REQUEST_INITIATE|replace_wait_audit|replace_pending|refund_authorized/i.test(
        status,
      )
    ) {
      simpleStatus = SimpleProcessStatus.Processing;
    } else {
      simpleStatus = SimpleProcessStatus.Pending;
    }
  } else {
    const status = statusRaw as ShopeeArgueOrdertatus;
    allowDispute = false;
    if (/^UNKNOWN|PROCESSING|REQUESTED|IN_CANCEL$/i.test(status)) {
      allowDispute = true;
      simpleStatus = SimpleProcessStatus.Pending;
    } else if (/^JUDGING|SELLER_DISPUTE$/i.test(status)) {
      simpleStatus = SimpleProcessStatus.Processing;
    } else {
      simpleStatus = SimpleProcessStatus.Done;
    }
  }
  return { simpleStatus, allowDispute };
};
